/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Faster_TInputs */

const en_funnel_ob_goal_faster_t = /** @type {(inputs: Funnel_Ob_Goal_Faster_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get through more, faster`)
};

const es_funnel_ob_goal_faster_t = /** @type {(inputs: Funnel_Ob_Goal_Faster_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar más, y más rápido`)
};

/**
* | output |
* | --- |
* | "Get through more, faster" |
*
* @param {Funnel_Ob_Goal_Faster_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_faster_t = /** @type {((inputs?: Funnel_Ob_Goal_Faster_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Faster_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_faster_t(inputs)
	return en_funnel_ob_goal_faster_t(inputs)
});